import { Component, OnInit, NgZone, Output, EventEmitter } from '@angular/core';
import { FswService } from '@services/fsw.service';
import { AuthService } from '@services/auth.service';
import { NgxSpinnerService } from "ngx-spinner";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4geodata_india2019High from "@amcharts/amcharts4-geodata/india2019High";
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-list-vehicle-statewise-home',
  templateUrl: './list-vehicle-statewise-home.component.html',
  styleUrls: ['./list-vehicle-statewise-home.component.scss']
})
export class ListVehicleStatewiseHomeComponent implements OnInit {
  p: number = 1;
  itemsPerPage: number = 10;
  vehiclesData: any[] | undefined;
  stateCode: any
  role: any
  showMapPannel: any
  mapData:any
  totalVehicle:number=0;
  
  constructor(private fswService: FswService, private authService: AuthService, private spinnerService: NgxSpinnerService, private zone: NgZone) { }

  ngOnInit(): void {
    this.getvehicleCount();
  }
   vehicles: any[] = [{ vehicle_title: "test title", vehicle_desc: "Test Description", no_of_trainees: "2" }]

  userName: any;
  getvehicleCount() {
    this.totalVehicle=0;
    var data= [];
    var mapData =[];
    this.spinnerService.show();
    this.userName = this.authService.getUserName();
    this.role = this.authService.getRole();

     //  if(this.role==null) 
    if (this.role == 'ADMIN' || this.role == 'PMU' || this.role == 'SO'||this.role=='IT-TEAM'||
    this.role==null||this.role=='USER')
    {
    //if(this.role==null)
      if (this.role == 'ADMIN' || this.role == 'PMU' || this.role == 'SO'||this.role=='IT-TEAM'||
      this.role==null||this.role=='USER')
        this.stateCode = 'ALL'
      else
        this.stateCode = this.authService.getState();

      this.fswService.getVehicleListCount(this.stateCode)
        .subscribe(res => {
          this.vehiclesData = res;
          console.log(this.vehiclesData)
          this.vehiclesData.forEach(val =>{
            this.totalVehicle+=val.total;
             mapData.push(Object.assign({}, val))
          }
        );
        console.log(mapData);
          
        
          mapData.forEach((item: any)=>{
            if(item.stateCode=='KE')
              item.stateCode='KL'
            if(item.stateCode=='BI')
            item.stateCode='BR'
            if(item.stateCode=='HI')
            item.stateCode='HP'
            if(item.stateCode=='TE')
              item.stateCode='TG'
            if(item.stateCode=='ME')
              item.stateCode='ML'
            if(item.stateCode=='CG')
              item.stateCode='CT'
              if(item.stateCode=='GO')
              item.stateCode='GA'
              if(item.stateCode=='HA')
              item.stateCode='HR'
              if(item.stateCode=='LK')
              item.stateCode='LD'
              if(item.stateCode=='MA')
              item.stateCode='MN'
              if(item.stateCode=='ME')
              item.stateCode='ML'
              if(item.stateCode=='MI')
              item.stateCode='MZ'
              if(item.stateCode=='NG')
              item.stateCode='NL'
              if(item.stateCode=='PJ')
              item.stateCode='PB'
              if(item.stateCode=='SI')
              item.stateCode='SK'

              if(item.stateCode=='LA')
              item.stateCode='LK'

              data.push({id:'IN-'+item.stateCode, name:item.stateName, value:item.total})

          })
          console.log(this.vehiclesData)
          this.openMap(data)
          this.spinnerService.hide();
        });
    }
    else if (this.role == 'RO') {
      var regionCode = localStorage.getItem("REGIONCODE");

      this.fswService.getVehicleByRegion(regionCode)
        .subscribe(res => {
          this.vehiclesData = res;
          this.spinnerService.hide();
        });

    }
  }

  openMap(data) 
  {

    this.showMapPannel = true;
    this.mapData = data
    this.zone.runOutsideAngular(() => {
      let map = am4core.create('appOnlineChartDiv', am4maps.MapChart);
      try {

        map.paddingRight = 5;
        map.geodata = am4geodata_india2019High;

        // Set projection
        map.projection = new am4maps.projections.Miller();

        // Create map polygon series
        var polygonSeries = map.series.push(new am4maps.MapPolygonSeries());

        // Exclude Antartica
        polygonSeries.exclude = ["AQ"];
        //polygonSeries.include = ["LA"];


        // Make map load polygon (like country names) data from GeoJSON
        polygonSeries.useGeodata = true;

        polygonSeries.heatRules.push({
          "property": "fill",
          "target": polygonSeries.mapPolygons.template,
          "min": am4core.color("#d4dfe9"),
          "max": am4core.color("#0e4777")
        });

        // Configure series
        var polygonTemplate = polygonSeries.mapPolygons.template;
        polygonTemplate.tooltipText = "{name}: {value}";
        polygonSeries.data = JSON.parse(JSON.stringify(this.mapData));
        polygonTemplate.fill = am4core.color("#c73c45");
        var hs = polygonTemplate.states.create("hover");
        hs.properties.fill = am4core.color("#c73c45");

      }
      catch (e) {
        map.raiseCriticalError(new Error("Map geodata could not be loaded. Please download the latest <a href=\"https://www.amcharts.com/download/download-v4/\">amcharts geodata</a> and extract its contents into the same directory as your amCharts files."));
      }

      let gradient = new am4core.LinearGradient();
      gradient.rotation = 90;
      polygonTemplate.fill = am4core.color("#c777ba");
      polygonTemplate.propertyFields.fill = "fill";

      polygonTemplate.events.on("hit", function (ev) {
        map.closeAllPopups();
        let dataContext: any = Object.assign({}, ev.target.dataItem.dataContext)
      });
    });
  }


}
